<script setup>
import { computed } from 'vue'
import { useConveyancingCaseStore } from '~/stores/conveyancing-cases.js'

const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
})

const conveyancingCaseStore = useConveyancingCaseStore()

const formData = computed(() => {
  let node = props.context.node
  while (node.parent) {
    node = node.parent
  }
  return node.value || {}
})

const casePropertyAddress = computed(() => conveyancingCaseStore.conveyancingCase?.sale_property?.full_address)

const addressToCompare = computed(() => {
  const isIdentical = formData.value['selling_details.is_address_identical_to_residing_address']

  const addressKey = isIdentical === 'Yes' || isIdentical === true ? 'clients.client1.address' : 'selling_details.selling_property_address'

  return formData.value[addressKey]?.full_address
})

const normalizeAddress = (str) =>
  str
    .toLowerCase()
    .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, '')
    .replace(/\s+/g, ' ')
    .trim()

const tokenize = (str) => str.split(' ').filter(Boolean)

const addressesMatch = (address1, address2) => {
  const normalized1 = normalizeAddress(address1)
  const normalized2 = normalizeAddress(address2)

  // Exact match
  if (normalized1 === normalized2) return true

  // Partial containment match
  if (normalized1.includes(normalized2) || normalized2.includes(normalized1)) return true

  // Token-based match (all case tokens present in entered address)
  const tokens1 = tokenize(normalized1)
  const tokens2 = tokenize(normalized2)

  return tokens2.every((token) => tokens1.includes(token))
}

const showAddressMismatchWarning = computed(() => {
  if (!casePropertyAddress.value || !addressToCompare.value) return false

  return !addressesMatch(addressToCompare.value, casePropertyAddress.value)
})
</script>

<template>
  <el-row v-if="showAddressMismatchWarning" class="mb-3 mt-1">
    <el-col :span="24">
      <el-alert type="warning" :closable="false" show-icon>
        The address you have entered differs from the property address on your case. Please ensure this is correct.
      </el-alert>
    </el-col>
  </el-row>
</template>
